import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const rpl11 = {
    label: "Loan Case",
    pageLabel: "Loan Case",
    starting: true,
    url: "rpl11",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Region",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "region",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Expand Tree Nodes",
            name: "ExpandTreeNodes",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Parent Branch",
            label: "Parent Branch",
            name: "parentbranch",
            description: "Enter Parent Branch"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Parent Branch ",
            name: "parentbranch",
            description: "Enter Parent Branch Code"
          },
          {
            inputType: "showdata",
            data: "Main Branch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "with Region",
            name: "withRegion",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product",
            label: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "With Branch",
            name: "WithBranch",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As on Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "dateFrom",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "With Product",
            name: "WithProduct",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product Type",
            label: "Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "With Product & Branch",
            name: "WithProductBranch",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account Type",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Account Type",
            name: "Accounttype",
            description: "Enter Account Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Want OD of FD Loan",
            name: "WantODofFDLoan",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Loan Term",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Short Term",
                value: "Short Term"
              },
              {
                label: "Medium Term",
                value: "Medium Term"
              },
              {
                label: "High Term",
                value: "High Term"
              },
             ],
            placeHolder: "Loan Term",
            name: "LoanTerm",
            description: "Enter Loan Term"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Detail Balance",
            name: "DetailBalance",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Secured/Unsecured",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Secured",
                value: "Secured"
              },
              {
                label: "UnSecured",
                value: "UnSecured"
              },
             ],
            placeHolder: "Secured/Unsecured",
            name: "SecuredUnsecured",
            description: "Enter Secured"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Sanction",
            name: "PrintSanction",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Expired",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Expired",
                value: "Expired"
              },
              {
                label: "Not Expired",
                value: "Not Expired"
              },
             ],
            placeHolder: "Expired",
            name: "Expired",
            description: "Enter Expired"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Distrurse Amount",
            name: "PrintDistrurseAmount",
            description: ""
          },  
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "PA/NPA",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "All",
                value: "All"
              },
              {
                label: "PA",
                value: "PA"
              },
              {
                label: "NPA",
                value: "NPA"
              },
             ],
            placeHolder: "",
            name: "PA_NPA",
            description: "Enter PA/NPA"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print NPA",
            name: "PrintNPA",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Overdue",
            name: "PrintOverdue",
            description: ""
          },                          
    ]
}

export default rpl11;